export default {
  callCenter: {
    signIn: '签入',
    signOut: '签出',
    setIdle: '置闲',
    setBusy: '置忙',
    hangup: '挂断',
    monitor: '监听',
    signInSuccess: '签入成功',
    signOutSuccess: '签出成功',
    setIdleSuccess: '置闲成功',
    setBusySuccess: '置忙成功',
    notSignedIn: '未签入',
    idle: '空闲中',
    busy: '忙碌中',
    all: '全部',
    callDuration: '通话时长',
    todayCallCount: '今日通话次数',
    beginCallout: '开始外呼',
    endCallout: '结束外呼',
    addBinding: '+新增绑定关系',
    operation: '操作',
    unbind: '解绑',
    unbindConfirm: '解绑确认',
    unbindConfirmText: '点击解绑后将自动解绑分机号和校区的绑定关系，解绑后校区不可继续使用，确认解绑吗？',
    addBindTitle: '新增绑定关系',
    campusId: '校区ID',
    pleaseEnterCampusId: '请输入校区ID',
    trafficSystem: '话务系统',
    pleaseSelectTrafficSystem: '请选择话务系统',
    hantianSystem: '汉天话务系统',
    yixunSystem: '易迅话务系统',
    extNo: '分机号',
    agentNo: '坐席号',
    pleaseEnterExtNo: '请输入分机号',
    pleaseEnterAgentNo: '请输入坐席号',
    outboundDisplayPhone: '外呼显示手机号',
    pleaseEnterOutboundPhone: '请输入外呼显示手机号',
    outboundPhoneTip: '注意：外显手机号暂只支持移动手机号',
    addExtSeat: '+新增分机和坐席号',
    delete: '删除',
    cancel: '取 消',
    confirm: '确 认',
    campusName: '校区名称',
    bindUser: '操作人',
    bindTime: '操作时间',
    unbindSuccess: '解绑成功',
    unbindFail: '解绑失败',
    pleaseEnterCampusIdErr: '请输入校区ID',
    pleaseSelectTrafficSystemErr: '请选择话务系统',
    pleaseEnterExtNoErr: '请输入分机号',
    pleaseEnterAgentNoErr: '请输入坐席号',
    operationSuccess: '操作成功',
    operationFail: '操作失败',
    campus: '校区',
    pleaseEnterExtNoPlaceholder: '请输入分机号',
    pleaseEnterAgentNoPlaceholder: '请输入坐席号',
    workbenchTitle: '外呼工作台',
    realPhone: '真实手机号：',
    displayPhone: '外显手机号：',
    callNow: '立即呼出',
    endCall: '结束通话',
    followPerson: '跟进人:',
    followInfo: '跟进信息:',
    more: '更多',
    noFollowYet: '该线索尚未被跟进',
    cluePhone: '线索手机号:',
    clueSource: '线索来源:',
    studentName: '学生姓名',
    grade: '年级',
    familyMember1: '家庭成员1',
    familyMember2: '家庭成员2',
    pleaseFill: '请填写',
    pleaseSelect: '请选择',
    queryTimeRange: '查询时间段',
    belongToAgent: '所属客服',
    callDurationRankQueryTime: '查询时间',
    callDurationRankCustomerService: '所属客服',
    callDurationRankNamePlaceholder: '名称',
    callDurationRankCallType: '呼叫类型',
    callTime: '通话时间',
    recordDuration: '录音时长',
    statusPlaceholder: '状态',
    callDurationRankAgentName: '坐席姓名',
    agentStatus: '坐席状态',
    todayFirstSignInTime: '今日首次签入时间',
    lastCallTime: '最后通话时间',
    todayConnectedCount: '今日接通次数',
    todayTotalCallDuration: '今日通话总时长',
    callDurationRankFirstCall: '第一通电话',
    callDurationRankLastCall: '最后一通电话',
    callDurationRankCallCount: '呼叫数量',
    callDurationRankConnectedCount: '接通数量',
    callDurationRankEffectiveConnectedCount: '有效接通数量',
    callDurationRankConnectedRate: '接通率',
    callDurationRankCallDuration: '呼叫时长',
    callDurationRankTotalCallDuration: '通话总时长',
    callDurationRankAverageCallDuration: '平均通话时长',
    callDurationRankType: '类型',
    callDurationRankBelongCampus: '所属校区',
    today: '今天',
    last7Days: '最近7天',
    last30Days: '最近30天',
    inbound: '呼入',
    outbound: '呼出',
    callerNo: '主叫号码',
    calleeNo: '被叫号码',
    pleaseEnterCallerNo: '请输入主叫号码',
    pleaseEnterCalleeNo: '请输入被叫号码',
    record0_15: '0秒-15秒',
    record15_30: '15秒-30秒',
    record30_60: '30秒-1分钟',
    record60_180: '1分钟-3分钟',
    record180_300: '3分钟-5分钟',
    record300_600: '5分钟-10分钟',
    record600Plus: '大于10分钟',
    phonePlaceholder: '手机号码',
    gradeEditOnce: '年级仅限修改一次',
    studentGender: '学生性别',
    school: '学校',
    birthday: '出生日期',
    homeAddress: '家庭住址',
    intentLevel: '意向程度',
    tag: '标签',
    remark: '备注',
    followStatus: '跟进状态',
    nextFollowTime: '下次跟进时间',
    pleaseSelectFollowStatus: '请选择跟进状态',
    promiseVisitTime: '诺访时间:',
    visitTime: '到访时间:',
    selectPromiseVisitTime: '选择诺访时间',
    selectVisitTime: '选择到访时间',
    visitStore: '到访门店:',
    pleaseSelectVisitStore: '请选择到访门店',
    followDesc: '跟进描述:',
    transferClue: '转交线索',
    saveRecord: '保存记录',
    saveSuccess: '保存成功',
    saveFail: '保存失败',
    stageK1: '小班',
    stageK2: '中班',
    stageK3: '大班',
    grade1: '一年级',
    grade2: '二年级',
    grade3: '三年级',
    grade4: '四年级',
    grade5: '五年级',
    grade6: '六年级',
    grade7: '七年级',
    grade8: '八年级',
    grade9: '九年级',
    gradeH1: '高一',
    gradeH2: '高二',
    gradeH3: '高三',
    gradeH4: '高四',
    gradeCommon: '通用',
    followPhone: '已电话',
    followWechat: '已加微',
    followPromise: '已诺访',
    followVisit: '已到访',
    followInvalid: '已失效',
    followDeal: '已成交',
    callMakecall: '发起呼叫',
    callOutcall: '接通坐席',
    callOutringing: '坐席振铃',
    callConnecting: '正在接通中',
    callAfter: '通话结束',
    callAgentidle: '坐席空闲',
    callCalling: '正在呼叫',
    callPlaytts: '正在播放工号',
    callIncall: '坐席接听',
    callAnswer: '通话中',
    totalCallDuration: '总通话时长',
    totalCallCount: '累计通话次数',
    successRate: '接通率',
    effectiveVsTotal: '有效人数/总人数',
    avgCallDurationLabel: '平均通话时长',
    minutesUnit: '分钟',
    addCallButton: '新增通话',
    showOnlyUnanswered: '仅显示未接电话',
    callerColumn: '外呼人',
    callTypeColumn: '呼叫方式',
    leadNameColumn: '线索姓名',
    leadPhoneColumn: '线索手机号',
    callTimeColumn: '呼叫时间',
    phoneStatusColumn: '号码状态',
    callDurationColumn: '通话时长',
    callRecordingColumn: '通话录音',
    playText: '播放',
    downloadText: '下载',
    viewFollowRecord: '查看跟进记录',
    newCallInputLabel: '请输入您要呼叫的电话号码',
    newCallInputPlaceholder: '请输入',
    redialTooltip: '回拨',
    recordingDialogTitle: '外呼录音播放',
    recordingCallerLabel: '外呼人:',
    cancelOrderConfirmText: '请确认是否取消订单，一旦取消，已支付款项会退回对应的代理商账户和调整对应期货订单额度！',
    payDeductTip: '本次支付将扣除：',
    unopenedTitle: '外呼功能未开通',
    unopenedMessage: '亲爱的经销商您好，您当前使用的外呼服务处于未开通状态，您可点击"前往开通"按钮进行开通或续期操作',
    thinkAgain: '再想想',
    goToOpen: '前往开通',
    overdueTitle: '外呼功能已欠费',
    overdueMessage: '亲爱的经销商您好，您当前使用的外呼服务已超出使用话费的额度，您可点击"前往充值"按钮进行话费充值操作',
    goToRecharge: '前往充值',
    paySuccessResult: '成功支付{symbol}{money}{unitSuffix}',
    payFailResult: '未能成功支付{symbol}{money}{unitSuffix}',
    iKnow: '我知道了',
    male: '男',
    female: '女',
    indicatorTipIntro: '结合您当前设置的查询时间、通话时长、跟进状态、号码状态、<br>外呼人、线索查询等条件',
    totalCallDurationFormula: '总通话时长 = 当前条件下全部外呼记录的通话时长总和',
    totalCallCountFormula: '累计通话次数 = 当前条件下全部外呼记录的总和',
    successRateFormula: '接通率 = 当前条件下实际接通的外呼记录总和 / 全部外呼记录总和 * 100%',
    effectiveEfficiencyFormula: '有效人效=当前条件下平均每天平均每个外呼人的实际接通外呼数量',
    totalEfficiencyFormula: '总人效=当前条件下平均每天平均每个外呼人的总外呼数重',
    avgCallDurationFormula: '平均通话时长 = 当前条件下全部外呼记录的通话时长平均值',
    presalePrice: '预售优惠价',
    originalPrice: '原价{symbol}406',
    providerTip: '作业帮、猿辅导同一供应商提供',
    providerTipPrefix: '*外呼技术由',
    operatorTip: '*涵盖全国各地域三大运营商号码资源',
    localNumberTip: '无需自行准备号码资源',
    localNumberTipPrefix: '*系统自动分配并外显本地号码，',
    markTip: '解决号码标记和封禁问题',
    markTipPrefix: '*可',
    newOpenTip: '*新开通',
    newOpenTipSuffix: '需支付技术开通费，后续续费不再重复收取',
    monthlyTipPrefix: '*按月结算，',
    monthlyTip: '不限使用人数',
    openFeeLabel: '开通费：',
    openFeeDiscount: '限时优惠1折，原价288.00元',
    packageFeeLabel: '套餐费：',
    packageFeeDetail: '不限人数，含500分钟免费时长，超出部分0.12元/分钟',
    openMonthsLabel: '开通月数：',
    monthUnit: '月',
    presaleMaxMonths: '预售最多开通12个月',
    payTipPrefix: '支付前请您先阅读并勾选外呼服务的',
    agreementLinkText: '开通使用协议',
    totalLabel: '合计：',
    yuanUnit: '元',
    validityMonths: '/有效期{months}个月',
    payCancel: '取消',
    payConfirm: '付款',
    voucherAccount: '裂变奖金账户',
    cashAccount: '现金账户',
    goldAccount: '金账户',
    deliveryAccount: '提货券帐户',
    accountYuan: '{amount}元'
  }
}
